module.exports = __webpack_public_path__ + "img/组 131.baf45750.png";